import { certificates } from "../constants/certificates";
import AnimatedHeaderSection from "../components/AnimatedHeaderSection";
import CertificateModal from "../components/CertificateModal";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef, useState } from "react";

const Achievements = () => {
  const cardRefs = useRef([]);
  const [selectedCertificate, setSelectedCertificate] = useState(null);

  const text = `Certifications, achievements and milestones
that shaped my journey as an engineer.`;

  useGSAP(() => {
    cardRefs.current.forEach((card) => {
      if (!card) return;

      gsap.from(card, {
        y: 120,
        opacity: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: card,
          start: "top 85%",
        },
      });
    });
  }, []);

  return (
    <section id="achievements" className="min-h-screen bg-white py-24">
      <AnimatedHeaderSection
        subTitle="Milestones & Recognition"
        title="Achievements"
        text={text}
        textColor="text-black"
        withScrollTrigger={true}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 px-10 mt-16">
        {certificates.map((cert, index) => (
          <div
            key={cert.id}
            ref={(el) => (cardRefs.current[index] = el)}
            className="group relative rounded-2xl overflow-hidden p-[2px] bg-gradient-to-br from-black via-neutral-800 to-black hover:via-neutral-600 transition-all duration-500"
          >
            <div className="relative rounded-2xl overflow-hidden bg-neutral-950 hover:shadow-2xl transition-all duration-500">
              {/* Certificate Image */}
              <div className="overflow-hidden">
                <img
                  src={cert.image}
                  alt={cert.title}
                  className="w-full h-56 object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>

              {/* Information */}
              <div className="p-6 bg-black/20 backdrop-blur-xl rounded-b-2xl">
                <h3 className="text-gray-200 text-xl font-semibold mb-1">
                  {cert.title}
                </h3>

                <p className="text-gray-300 text-sm">{cert.issuer}</p>

                <p className="text-xs uppercase tracking-widest text-gray-400 mt-2">
                  {cert.year}
                </p>
              </div>

              {/* Hover Overlay */}
              <button
                onClick={() => setSelectedCertificate(cert)}
                className="absolute inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300"
              >
                <span className="px-6 py-3 rounded-full border border-white text-white font-medium hover:bg-white hover:text-black transition">
                  View Certificate
                </span>
              </button>
            </div>
          </div>
        ))}
      </div>

      <CertificateModal
        certificate={selectedCertificate}
        onClose={() => setSelectedCertificate(null)}
      />
    </section>
  );
};

export default Achievements;
